import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f4cf9b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["open"]

import { reactive } from "vue";
import CustomPic from "./CustomPic.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomDisclosure',
  props: {
  open: {
    type: Boolean,
    default: () => false,
  },
},
  setup(__props) {



var state = reactive({
  open: false,
});

function handleToggle(event: Event) {
  const target = event.target as HTMLDetailsElement;
  state.open = target.open;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("details", {
    open: _unref(state).open,
    onToggle: handleToggle,
    class: "detail"
  }, [
    _createElementVNode("summary", null, [
      _renderSlot(_ctx.$slots, "header"),
      _createVNode(CustomPic, {
        class: "disclosure-icon",
        "picture-path": "SVG/arrow.svg",
        auto: true,
        height: "2rem"
      })
    ]),
    _createElementVNode("p", null, [
      _renderSlot(_ctx.$slots, "body")
    ])
  ], 40, _hoisted_1))
}
}

})